import dayjs from 'dayjs';
import { Locale as AntdLocale } from 'antd/lib/locale';
import antdEnGb from 'antd/locale/en_GB';
import antdEnUs from 'antd/locale/en_US';
import dayjsEnGb from 'dayjs/locale/en-gb';
import { DAYJS_EN_US, US_CUSTOM_LOCALE_DATA } from '@app/main/locales/us';
import { UK_CUSTOM_LOCALE_DATA } from '@app/main/locales/uk';
import { Locale, CustomLocaleData } from '@app/ui';
import { Locale as AppLocale } from '@app/main/api';

type DayjsLocale = ILocale;

// TODO remove when multiple timezones support is implemented
dayjs.tz.setDefault('Europe/London');
dayjs.tz.default = 'Europe/London';

interface LocaleData {
  dayjsLocale: DayjsLocale;
  antdLocale: AntdLocale;
  customData: CustomLocaleData;
}

const appLocalesData: Record<AppLocale, LocaleData> = {
  [AppLocale.uk]: {
    dayjsLocale: dayjsEnGb,
    antdLocale: antdEnGb,
    customData: UK_CUSTOM_LOCALE_DATA,
  },
  [AppLocale.us_EST]: {
    dayjsLocale: DAYJS_EN_US,
    antdLocale: antdEnUs,
    customData: US_CUSTOM_LOCALE_DATA,
  },
};

Object.keys(appLocalesData).forEach((locale) => {
  Locale.add(locale, appLocalesData[locale as AppLocale]);
});
